import { clientbookApi } from '../core/clientbook-api';

export const getCustomActivityTypes = async ({ archived = false, loadingStatusOff = false, axiosConfig = {} } = {}) => {
  return clientbookApi.get({
    url: '/merchants/customactivitytypes',
    query: { archived },
    loading: !loadingStatusOff,
    axiosConfig,
  });
};
